import React, { useMemo, useState } from 'react';

import ArrowImg from '../../../../../../assets/2025/arrow.gif';
import { CTitle, WTitle } from '../../components/Widget';
import { useParams } from 'react-router-dom';
import section3_3_1 from '../../../../../../assets/2025/topic1000/section3_3_1.png';
import section3_3_2 from '../../../../../../assets/2025/topic1000/section3_3_2.png';
import section3_3_2_m from '../../../../../../assets/2025/topic1000/section3_3_2_m.png';
import Quiz from '../../components/Quiz';
import { useUpdateComponentState } from '../../../hooks';

interface ISection0Props {
  settings: any;
}

const Section3: React.FunctionComponent<ISection0Props> = ({ settings }) => {
  const ID = '4';
  const param = useParams();
  const p_course = param.course || '';
  const p_topic = param['*'] || 'welcome';
  const paragraphsSettings = useMemo(
    () => settings?.paragraphs[3],
    [settings?.paragraphs]
  );
  const { quiz } = paragraphsSettings;
  const [state, setState] = useState({
    state1: false,
    state2: false,
  });
  const [playState, setPlayState] = useState({
    step1: {
      play: 1,
      isPlayed: false,
      num: 5,
      component: '2025-topic1000-section3-2',
    },
    step2: {
      play: 1,
      isPlayed: false,
      num: 5,
      component: '2025-topic1000-section3-4',
    },
  });
  const updateComponentState = useUpdateComponentState();

  const startPlay = (next = 1, field: 'step1' | 'step2') => {
    const cur = playState[field];
    if (cur.isPlayed) {
      return;
    }
    next += 1;
    setPlayState({
      ...playState,
      [field]: { ...cur, play: next, isPlayed: true },
    });
    updateComponentState(p_course, p_topic, ID, cur.component);
    if (next <= cur.num) {
      setTimeout(() => startPlay(next, field), 1000);
    }
  };

  const [quizState, setQuizState] = useState(false);
  const quizComplete = () => {
    setQuizState(true);
  };

  React.useEffect(() => {
    if (state.state1) {
      updateComponentState(p_course, p_topic, ID, '2025-topic1000-section3-1');
    }
    if (state.state2) {
      updateComponentState(p_course, p_topic, ID, '2025-topic1000-section3-3');
    }
  }, [p_course, p_topic, state]);

  React.useEffect(() => {
    if (quizState) {
      updateComponentState(
        p_course,
        p_topic,
        ID,
        '2025-topic1000-section3-question'
      );
    }
  }, [p_course, p_topic, quizState]);

  return (
    <div className="topic-section-3">
      <WTitle title={paragraphsSettings?.title}></WTitle>

      <div id="2025-topic1000-section3-1" className="example_box_1">
        <CTitle title={paragraphsSettings?.l1}></CTitle>
        <div className="content_box">
          <img src={section3_3_1} alt="" className="l1 pc_hide" />
          <div className="l2">
            <div
              className="left"
              style={{ display: state.state1 ? '' : 'none' }}
            >
              <p
                className="p2"
                dangerouslySetInnerHTML={{ __html: paragraphsSettings?.l3 }}
              />
            </div>
            <div
              className="right"
              onClick={() => setState({ ...state, state1: true })}
            >
              <span className="p1">{paragraphsSettings?.l2}</span>
              <img
                src={ArrowImg}
                alt=""
                style={{ display: state.state1 ? 'none' : '' }}
                className="arrow_icon"
              />
            </div>
            <img src={section3_3_2} alt="" className="pc_hide" />
            <img src={section3_3_2_m} alt="" className="mobile_show img_pic" />
          </div>
        </div>
      </div>

      <div
        id="2025-topic1000-section3-2"
        className="prevent-best-practice-container"
      >
        <div className="title-box">
          <CTitle title={paragraphsSettings?.l4}></CTitle>
        </div>
        <div
          className="prevent-best-practice"
          onClick={() => startPlay(1, 'step1')}
        >
          {paragraphsSettings?.l5?.map(
            (item: { no: string; desc: string }, index: number) => (
              <div
                key={item.no}
                className={`prevent-best-practice-item ${
                  playState.step1.play > index ? 'fade-in' : ''
                }`}
              >
                <div className="item-no">{item.no}</div>
                <div className="item-desc">{item.desc}</div>
                {index < 1 && (
                  <div
                    className="arrow"
                    style={{
                      display: playState.step1.isPlayed ? 'none' : 'block',
                    }}
                  >
                    <img src={ArrowImg} alt="" />
                  </div>
                )}
              </div>
            )
          )}
        </div>
      </div>

      <div id="2025-topic1000-section3-3" className="how-content-container">
        <CTitle title={paragraphsSettings?.l6}></CTitle>
        <div className="how-content">
          <div
            className="how-text-box left"
            onClick={() => setState({ ...state, state2: true })}
          >
            <p>{paragraphsSettings?.l7}</p>
            <div
              className="arrow"
              style={{ display: state.state2 ? 'none' : 'block' }}
            >
              <img src={ArrowImg} alt="" />
            </div>
          </div>
          <div
            className={`how-text-box right ${state.state2 ? 'fade-in' : ''}`}
          >
            <p
              dangerouslySetInnerHTML={{
                __html: paragraphsSettings?.l8,
              }}
            />
          </div>
          <div
            className="back-left"
            onClick={() => setState({ ...state, state2: true })}
          ></div>
          <div className="back-right"></div>
        </div>
        <div className="bottom-decoration"></div>
      </div>

      <div id="2025-topic1000-section3-4" className="best-practice-container">
        <div className="title-box">
          <CTitle title={paragraphsSettings?.l9}></CTitle>
        </div>
        <div className="best-practice" onClick={() => startPlay(1, 'step2')}>
          {paragraphsSettings?.l10?.map(
            (item: { no: string; desc: string }, index: number) => (
              <div
                key={item.no}
                className={`best-practice-item ${
                  playState.step2.play > index ? 'fade-in' : ''
                }`}
              >
                <div className="item-no">{item.no}</div>
                <div className="item-desc">{item.desc}</div>
                {index < 1 && (
                  <div
                    className="black-arrow"
                    style={{
                      display: playState.step2.isPlayed ? 'none' : 'block',
                    }}
                  >
                    <img src={ArrowImg} alt="" />
                  </div>
                )}
              </div>
            )
          )}
        </div>
      </div>

      <div id="2025-topic1000-section3-question" className="topic-quiz">
        <Quiz
          title={paragraphsSettings?.questionTitle}
          description={quiz?.description}
          question={quiz?.question}
          options={quiz?.options}
          onCompleted={quizComplete}
        />
      </div>
    </div>
  );
};

export default Section3;
